import React from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import SingleBlog from './SingleBlog'

const SinglePageScreen = () => {
  return (
    <div>
      <Header />
      <SingleBlog />
      <Footer />
    </div>
  )
}

export default SinglePageScreen